import normalizeCondition from "../utils/normalizeCondition";
import { getConditionColor, getLanguageCountryCode, getWantsConditionLabel, getWantsLanguageLabel } from "../wantsSettingsOptions";

const basePillStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "20px",
  minWidth: "20px",
  height: "20px",
  padding: 0,
  borderRadius: "6px",
  color: "#ffffff",
  fontSize: "11px",
  fontWeight: 700,
  lineHeight: 1,
  verticalAlign: "middle",
  textAlign: "center"
};

const baseTextPillStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: "20px",
  padding: "0 5px",
  borderRadius: "6px",
  fontSize: "11px",
  fontWeight: 700,
  lineHeight: 1,
  verticalAlign: "middle",
  textAlign: "center",
  boxSizing: "border-box"
};

export const CARD_ATTRIBUTE_PILL_BACKGROUNDS = {
  foil: "linear-gradient(to right, #0000ff, #ff0000)",
  altered: "#8b5a2b",
  signed: "#111111"
};

function renderAttributeContent(type) {
  if (type === "foil") {
    return "F";
  }

  if (type === "altered") {
    return (
      <svg width="10" height="10" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
          d="M10.9 2.2a1.5 1.5 0 0 1 2.1 0l.8.8a1.5 1.5 0 0 1 0 2.1l-7.6 7.6-2.9.8.8-2.9 7.6-7.6Z"
          fill="currentColor"
        />
        <path d="M9.8 3.3 12.7 6.2" stroke="#ffffff" strokeWidth="1" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg width="10" height="10" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M2 11.5c1.3-1.1 2.5-1.6 3.4-1.6 1.2 0 1.6 1.1 2.5 1.1.8 0 1.2-.5 1.6-1.5.6-1.3 1.2-4.6 2.8-4.6.8 0 1.3.8 1.7 2.4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2 13h12" stroke="#ffffff" strokeWidth="1" strokeLinecap="round" opacity="0.8" />
    </svg>
  );
}

function getAttributeStyle(type) {
  if (type === "foil") {
    return {
      ...basePillStyle,
      background: CARD_ATTRIBUTE_PILL_BACKGROUNDS.foil,
      textTransform: "uppercase"
    };
  }

  if (type === "altered") {
    return {
      ...basePillStyle,
      background: CARD_ATTRIBUTE_PILL_BACKGROUNDS.altered
    };
  }

  return {
    ...basePillStyle,
    background: CARD_ATTRIBUTE_PILL_BACKGROUNDS.signed
  };
}

export function LanguagePill({ language, title, style = {} }) {
  if (!language) {
    return null;
  }

  const countryCode = getLanguageCountryCode(language);
  const pillTitle = title || getWantsLanguageLabel(language);

  return (
    <span
      className={`fi fi-${countryCode}`}
      title={pillTitle}
      aria-label={pillTitle}
      style={{
        ...basePillStyle,
        borderRadius: "6px",
        overflow: "hidden",
        lineHeight: 1,
        boxSizing: "border-box",
        fontSize: "14px",
        boxShadow: "none",
        ...style
      }}
    />
  );
}

export function ConditionPill({ condition, any = false, anyLabel = "Any", title, style = {} }) {
  if (any) {
    return (
      <span
        title={anyLabel}
        aria-label={anyLabel}
        style={{
          ...baseTextPillStyle,
          minWidth: "22px",
          background: "#e2e8f0",
          color: "#334155",
          ...style
        }}
      >
        Any
      </span>
    );
  }

  const normalizedCondition = normalizeCondition(condition);

  if (!normalizedCondition) {
    return null;
  }

  const pillTitle = title || getWantsConditionLabel(normalizedCondition);

  return (
    <span
      title={pillTitle}
      aria-label={pillTitle}
      style={{
        ...baseTextPillStyle,
        minWidth: "22px",
        background: getConditionColor(normalizedCondition),
        color: normalizedCondition === "GD" ? "#111" : "#ffffff",
        textTransform: "uppercase",
        ...style
      }}
    >
      {normalizedCondition}
    </span>
  );
}

export default function CardAttributePill({ type, title }) {
  if (!["foil", "altered", "signed"].includes(type)) {
    return null;
  }

  return (
    <span title={title} aria-label={title} style={getAttributeStyle(type)}>
      {renderAttributeContent(type)}
    </span>
  );
}